module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/purchase/material-receipt-note/mr-note-form/mr-note-form.component.css
// module id = ./src/app/Pages/purchase/material-receipt-note/mr-note-form/mr-note-form.component.css
// module chunks = main